import { PQR_RECEPTION_CHANNEL_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { usePqrReceptionChannelList } from './hook';
import { PqrReceptionChannelListProps } from './props';

export const PqrReceptionChannelList = ({
    filters,
}: PqrReceptionChannelListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        usePqrReceptionChannelList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(
                    `${PQR_RECEPTION_CHANNEL_DETAIL}/${item.id}`,
                    '_blank'
                )
            }
        />
    );
};
